import { useState } from "react";
import { observer } from "mobx-react-lite";
import { useNavigate } from "react-router-dom";
import { authenticateUser, completeChangePassword } from "./cognito";
import { config } from "../../utils/config";
import { Box, Card, Divider, Stack, Typography } from "@mui/material";
import { Constants } from "../../utils/constants";
import { DefaultButton, GoogleLoginWidget, MainButton, MainInput, SuccessButton } from "..";

function Login({ authStore, navStore }) {
  const [loggingIn, setLoggingIn] = useState(false);
  const [error, setError] = useState("");
  const [newPasswordFlow, setNewPasswordFlow] = useState(false);
  const [cognitoUser, setCognitoUser] = useState(null);

  const [newPassword, setNewPassword] = useState(true);
  const [newPassword2, setNewPassword2] = useState(true);

  const [userName, setUserName] = useState("");
  const [password, setPassword] = useState("");
  const navigate = useNavigate();

  const onFinish = async (e) => {
    e.preventDefault();
    setError("");
    setLoggingIn(true);
    try {
      if (newPasswordFlow) {
        if (newPassword !== newPassword2) {
          setError("Password mismatch");
          setLoggingIn(false);
        } else {
          try {
            const user = await completeChangePassword(cognitoUser, newPassword);
            authStore.setSession(user);
            navigate("/");
          } catch (e) {
            setError(e.message);
            setLoggingIn(false);
          }
        }
      } else {
        const user = await authenticateUser(userName, password);
        authStore.setSession(user);
        navigate("/");
      }
      setLoggingIn(false);
    } catch (e) {
      if (e.type && e.type === "NEW_PASSWORD_REQUIRED") {
        setNewPasswordFlow(true);
        setCognitoUser(e.cognitoUser);
        setLoggingIn(false);
      } else {
        setLoggingIn(false);
        setError(e.message);
      }
    }
  };

  const onGoogleLogin = () => {
    const URL = `${config.AUTH_URL}/authorize?identity_provider=Google&redirect_uri=${config.REDIRECT_URI}&response_type=CODE&client_id=${config.COGNITO_CLIENT_ID}&scope=openid%20email%20profile`;
    window.location.replace(URL);
  };

  return (
    <Box sx={{
      padding: "auto",
      display: "flex",
      alignItems: "start",
      justifyContent: "center",
      pt: "3rem",
    }}>
      <Card
        sx={{
          padding: "3rem 2.5rem",
        }}
      >
        <Stack
          alignItems="center"
          justifyContent={"center"}
          spacing={`calc(${Constants.Styles.spacing} * 6)`}
        >
          <Typography sx={{
            fontSize: Constants.Styles.fontSize["3xl"],
            fontWeight: Constants.Styles.fontWeight.semiBold,
            lineHeight: Constants.Styles.lineHeight["3xl"],
          }}>Welcome back!</Typography>
          <Box
            component={"form"}
            noValidate
            onSubmit={onFinish}
          >
            {!newPasswordFlow && (
              <Stack
                spacing={2}
                sx={{
                  minWidth: { xs: 300, sm: 360, },
                }}
              >
                <GoogleLoginWidget onClick={onGoogleLogin} />
                <Divider>
                  OR
                </Divider>

                <MainInput
                  name="username"
                  label="Email address"
                  text="text"
                  value={userName}
                  onChange={(e) => setUserName(e.target.value)}
                />
                <MainInput
                  name="password"
                  label="Password"
                  text="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  isSecure={true}
                />
              </Stack>
            )}

            {newPasswordFlow && (
              <Box>
                <Typography sx={{
                  fontSize: Constants.Styles.fontSize.lg,
                  fontWeight: Constants.Styles.fontWeight.medium,
                  lineHeight: Constants.Styles.lineHeight.lg,
                }}>New password required</Typography>
                <Typography sx={{
                  fontSize: Constants.Styles.fontSize.base,
                  fontWeight: Constants.Styles.fontWeight.normal,
                  lineHeight: Constants.Styles.lineHeight.base,
                }}>{userName}</Typography>

                <Stack spacing={2}>
                  <MainInput
                    name="newPassword"
                    label="New Password"
                    text="password"
                    value={newPassword}
                    onChange={(e) => setNewPassword(e.target.value)}
                    isSecure={true}
                  />
                  <MainInput
                    name="newPassword1"
                    label="Re-enter Password"
                    text="password"
                    value={newPassword2}
                    onChange={(e) => setNewPassword2(e.target.value)}
                    isSecure={true}
                  />
                </Stack>
              </Box>
            )}
            {error && <Typography sx={{
              fontSize: Constants.Styles.fontSize.sm,
              color: Constants.Colors.light.destructive,
              mt: 2,
            }}>{error}</Typography>}
            <Box sx={{
              mt: 3,
            }}>
              <SuccessButton
                text={newPasswordFlow ? "Set Password" : "Login"}
                size="medium"
                type="submit"
                isSubmitting={loggingIn}
              />
            </Box>
            {!newPasswordFlow && (
              <Stack
                alignItems={"end"}
                justifyContent={"center"}
                sx={{
                  mt: 2,
                }}>

                <Box>
                  <MainButton
                    text={"Forgot password?"}
                    size="small"
                    onClick={() => navigate("/forgot")}
                  />
                </Box>
              </Stack>
            )}
          </Box>
        </Stack>
      </Card>
    </Box>
  );
}

export default observer(Login);
